<dx-popup
    #journalEntryDetail
    minWidth="150px"
    minHeight="150px"
    width="70%"
    height="90%"
    [title]="'GL Journal Entry ' + journalEntryParam?.journalEntryId"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let item of 'content'">
        <dx-box height="100%" width="100%" direction="col" class="journal-entry-detail-box">
            <dxi-item baseSize="auto" *ngIf="!!journalEntryDetailData">
                <dx-form
                    #journalEntryEditorForm
                    width="100%"
                    height="100%"
                    [colCount]="2"
                    [labelLocation]="defaultLabelLocation"
                >
                    <dxi-item itemType="group" [colCount]="2">
                        <dxi-item isRequired="true">
                            <dxo-label text="Post Date"></dxo-label>
                            <div *dxTemplate>
                                <dx-date-box
                                    [width]="120"
                                    [readOnly]="true"
                                    [(value)]="journalEntryDetailData.postDate"
                                    type="date"
                                    [displayFormat]="dateFormat"
                                ></dx-date-box>
                            </div>
                        </dxi-item>
                        <dxi-item *ngIf="!!journalEntryDetailData.reversalDate">
                            <dxo-label text="Reverse Date"></dxo-label>
                            <div *dxTemplate>
                                <dx-date-box
                                    [width]="120"
                                    [readOnly]="true"
                                    [(value)]="journalEntryDetailData.reversalDate"
                                    type="date"
                                    [displayFormat]="dateFormat"
                                ></dx-date-box>
                            </div>
                        </dxi-item>
                        <dxi-item itemType="empty"></dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" [colCount]="2">
                        <dxi-item>
                            <div *dxTemplate>
                                <dx-radio-group
                                    displayExpr="displayText"
                                    key="key"
                                    layout="horizontal"
                                    [width]="300"
                                    [readOnly]="true"
                                    [dataSource]="cashOrAccrualOptions"
                                    [(value)]="cashOrAccrualCodeObj"
                                ></dx-radio-group>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <div *dxTemplate class="attachment-icon">
                                <dx-toolbar width="100%">
                                    <dxi-item [visible]="journalEntryDetailData.allowAttachment" location="after">
                                        <div *dxTemplate>
                                            <app-attachment-editor
                                                [communityId]="journalEntryParam.communityId"
                                                [attachments]="journalEntryAttachments"
                                                (onAttachmentUpdate)="onAttachmentUpdate($event)"
                                            ></app-attachment-editor>
                                        </div>
                                    </dxi-item>
                                    <dxi-item location="after">
                                        <div *dxTemplate>
                                            <dx-button
                                                *ngIf="journalEntryDetailData.glJournalId"
                                                class="history-button"
                                                hint="Transaction History"
                                                [icon]="iconHistory"
                                                (onClick)="onHistoryClick()"
                                            ></dx-button>
                                        </div>
                                    </dxi-item>
                                </dx-toolbar>
                            </div>
                        </dxi-item>
                    </dxi-item>

                    <dxi-item isRequired="true" [colSpan]="2">
                        <dxo-label text="Description"></dxo-label>
                        <div *dxTemplate class="journal-entry-desc">
                            <dx-text-area
                                width="65%"
                                [height]="26"
                                [readOnly]="true"
                                [(value)]="journalEntryDetailData.description"
                            ></dx-text-area>
                        </div>
                    </dxi-item>

                    <dxi-item *ngIf="!!journalEntryDetailData.reversed && !!journalEntryDetailData.reversalDate">
                        <div *dxTemplate>
                            <span class="cc-text-required">This Journal Entry has been reversed</span>
                        </div>
                    </dxi-item>
                    <dxi-item
                        *ngIf="!!journalEntryDetailData.reversalOfJournalId && !journalEntryDetailData.reversalDate"
                    >
                        <div *dxTemplate>
                            <span class="cc-text-required">This is a reversal Journal Entry</span>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>

            <dxi-item [ratio]="1" *ngIf="!!journalEntryDetailData">
                <dx-data-grid
                    #jeDetailGrid
                    class="je-detail-grid"
                    height="95%"
                    width="100%"
                    [dataSource]="journalEntryDetailData.items"
                    [allowColumnReordering]="true"
                    [allowColumnResizing]="true"
                    [columnAutoWidth]="true"
                    [showBorders]="true"
                    [showColumnLines]="true"
                    [showRowLines]="true"
                    [repaintChangesOnly]="true"
                >
                    <dxo-paging [enabled]="false"></dxo-paging>
                    <dxo-pager [visible]="false"></dxo-pager>

                    <dxi-column [width]="50" caption="Item #" alignment="right" cellTemplate="itemNumber"></dxi-column>

                    <dxi-column dataField="glAccountDisplayText" dataType="string" [width]="200"></dxi-column>

                    <ng-container *ngIf="entityUsesSubcategory">
                        <dxi-column
                            dataField="subCategory"
                            dataType="string"
                            caption="Sub Category"
                            [width]="140"
                        ></dxi-column>
                    </ng-container>

                    <dxi-column
                        dataField="debit"
                        dataType="number"
                        caption="Debit"
                        [width]="110"
                        [editorOptions]="{ format: '$ #,##0.00' }"
                        [format]="currencyFormat"
                    ></dxi-column>
                    <dxi-column
                        dataField="credit"
                        dataType="number"
                        caption="Credit"
                        [width]="110"
                        [editorOptions]="{ format: '$ #,##0.00' }"
                        [format]="currencyFormat"
                    ></dxi-column>

                    <ng-container *ngIf="dimensionSource.length > 0">
                        <ng-container *ngFor="let col of dimensionSource">
                            <dxi-column
                                [width]="150"
                                dataType="string"
                                allowSorting="false"
                                [dataField]="col.dimensionOptionTitle"
                                [caption]="col.dimensionTitle"
                                cellTemplate="dimensionTemplate"
                            ></dxi-column>
                        </ng-container>
                    </ng-container>

                    <dxi-column
                        dataField="description"
                        dataType="string"
                        caption="Description"
                        [width]="220"
                    ></dxi-column>

                    <div *dxTemplate="let item of 'itemNumber'">
                        <span>
                            {{ item.row.rowIndex + 1 }}
                        </span>
                    </div>

                    <div *dxTemplate="let item of 'dimensionTemplate'">
                        <div *ngFor="let dim of item.data.dimensions">
                            <span *ngIf="!!dim.dimensionOptionTitle && item.column.caption === dim.dimensionTitle">
                                {{ dim.dimensionOptionTitle }}
                            </span>
                            <span *ngIf="!dim.dimensionOptionTitle && item.column.caption === dim.dimensionTitle">
                                {{ dim.dimensionOptionCode }}
                            </span>
                        </div>
                    </div>

                    <dxo-summary>
                        <dxi-total-item
                            column="debit"
                            summaryType="sum"
                            displayFormat="{0}"
                            [valueFormat]="currencyFormat"
                        ></dxi-total-item>
                        <dxi-total-item
                            column="credit"
                            summaryType="sum"
                            displayFormat="{0}"
                            [valueFormat]="currencyFormat"
                        ></dxi-total-item>
                    </dxo-summary>
                </dx-data-grid>
            </dxi-item>

            <dxi-item baseSize="auto" *ngIf="!!journalEntryDetailData">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                text="Cancel"
                                hint="Cancel"
                                type="default"
                                [icon]="iconCancel"
                                (onClick)="onHidden()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" *ngIf="hasDepositPopup()">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="View Deposit"
                                hint="View Deposit"
                                [icon]="iconSearch"
                                (onClick)="onViewDepositClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item
                        location="after"
                        *ngIf="!!journalEntryDetailData.allowEdit || !!journalEntryDetailData.allowLimitedEdit"
                    >
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Edit"
                                hint="Edit"
                                [icon]="iconEdit"
                                (onClick)="onEditOrDuplicateJEClick(false)"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                class="button-content"
                                text="Duplicate"
                                hint="Duplicate"
                                type="default"
                                [visible]="!!journalEntryDetailData.allowDuplicate"
                                [template]="'duplicateButtonTemplate'"
                                (onClick)="onEditOrDuplicateJEClick(true)"
                            >
                                <div *dxTemplate="let buttonData of 'duplicateButtonTemplate'">
                                    <div class="button-item-container">
                                        <i class="fas fa-copy"></i>
                                        <div class="button-content">{{ buttonData.text }}</div>
                                        <div *ngIf="isInternalUser">
                                            <i class="fas fa-key" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </div>
                            </dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                class="button-content"
                                text="Save Attachment"
                                hint="Save Attachment"
                                type="default"
                                [icon]="iconSave"
                                [visible]="!!journalEntryDetailData.allowAttachment"
                                (onClick)="onSaveAttachmentClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-transaction-history
    *ngIf="displayTransactionLogPopUp"
    [title]="transactionLogPopupTitle"
    [transactionLogResultData]="transactionLogResultData"
    [communityId]="communityId"
    (onTransactionLogClose)="displayTransactionLogPopUp = false"
></app-transaction-history>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#journalEntryDetail' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #journalEntryMessageBox></cc-message-box>
